import React from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAgencySettingsOptions, editStyleSettingsOptions } from '@generated';
import Yup from '~/util/yup';
import { ColorPickerFormField } from '~/shared/forms/controls/fields/ColorPickerFormField';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { Pill } from 'lucide-react';
import { LibraryForm } from '../shared/LibraryForm';

export const AgencyStyleSettingsSection = {
	settingsView: 'style',
	title: 'Style Settings',
	description: 'Customize the appearance and branding of your agency portal',
	TitleIcon: Pill
} satisfies SettingsSectionItem;

const validationSchema = Yup.object().shape({
	snDisciplineColor: Yup.string().label('SN Discipline Color').nullable().required(),
	ptDisciplineColor: Yup.string().label('PT Discipline Color').nullable().required(),
	otDisciplineColor: Yup.string().label('OT Discipline Color').nullable().required(),
	stDisciplineColor: Yup.string().label('ST Discipline Color').nullable().required(),
	mswDisciplineColor: Yup.string().label('MSW Discipline Color').nullable().required(),
	hhaDisciplineColor: Yup.string().label('HHA Discipline Color').nullable().required(),
	mhnDisciplineColor: Yup.string().label('MHN Discipline Color').nullable().required()
});

export function AgenyStyleSettingsForm() {
	const { data: settings } = useSuspenseQuery(getAgencySettingsOptions());

	return (
		<LibraryForm
			initialValues={{
				snDisciplineColor: settings.snDisciplineColor,
				ptDisciplineColor: settings.ptDisciplineColor,
				otDisciplineColor: settings.otDisciplineColor,
				stDisciplineColor: settings.stDisciplineColor,
				mswDisciplineColor: settings.mswDisciplineColor,
				hhaDisciplineColor: settings.hhaDisciplineColor,
				mhnDisciplineColor: settings.mhnDisciplineColor
			}}
			saveMutation={{
				...editStyleSettingsOptions,
				invalidateQueryKeys: [getAgencySettingsOptions().queryKey]
			}}
			validationSchema={validationSchema}
			{...AgencyStyleSettingsSection}
		>
			<ColorPickerFormField name="snDisciplineColor" />
			<ColorPickerFormField name="ptDisciplineColor" />
			<ColorPickerFormField name="otDisciplineColor" />
			<ColorPickerFormField name="stDisciplineColor" />
			<ColorPickerFormField name="mswDisciplineColor" />
			<ColorPickerFormField name="hhaDisciplineColor" />
			<ColorPickerFormField name="mhnDisciplineColor" />
		</LibraryForm>
	);
}
